import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import 'flowbite'
import './assets/styles.css'
import App from './App.vue'
import { initYandexMetrika, trackYandexPageView } from './config/yandexMetrika'

const routes = [
  {
    path: '/',
    name: 'dashboard',
    component: () => import('./views/DashboardView.vue'),
    meta: { title: 'Главная — ДоходПро', description: 'Быстрый расчёт дохода курьера за день, неделю и ближайшую выплату.' }
  },
  {
    path: '/shifts',
    name: 'shifts',
    component: () => import('./views/ShiftsView.vue'),
    meta: { title: 'Смены — ДоходПро', description: 'Учёт смен курьера: часы, заказы, условия, надбавки и итоговая сумма.' }
  },
  {
    path: '/payouts',
    name: 'payouts',
    component: () => import('./views/PayoutsView.vue'),
    meta: { title: 'Выплаты — ДоходПро', description: 'Контроль недельных выплат, ожидаемых сумм, фактических поступлений и расхождений.' }
  },
  {
    path: '/analytics',
    name: 'analytics',
    component: () => import('./views/AnalyticsView.vue'),
    meta: { title: 'Аналитика — ДоходПро', description: 'Статистика дохода курьера по дням, неделям, часам, заказам и налогам.' }
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('./views/SettingsView.vue'),
    meta: { title: 'Настройки — ДоходПро', description: 'Настройка ставок, надбавок, налогов, условий и периодов выплат.' }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

let initialNavigationCompleted = false

router.afterEach((to) => {
  document.title = to.meta.title || 'ДоходПро — расчёт дохода курьера'
  const description = document.querySelector('meta[name="description"]')
  if (description && to.meta.description) description.setAttribute('content', to.meta.description)
  if (initialNavigationCompleted) trackYandexPageView(to.fullPath, document.title)
  initialNavigationCompleted = true
})

initYandexMetrika()

createApp(App).use(router).mount('#app')

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  let refreshing = false

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return
    refreshing = true
    window.location.reload()
  })

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { updateViaCache: 'none' })
      .then((registration) => {
        registration.update().catch(() => undefined)

        registration.addEventListener('updatefound', () => {
          const worker = registration.installing
          if (!worker) return

          worker.addEventListener('statechange', () => {
            if (worker.state === 'installed' && navigator.serviceWorker.controller) {
              worker.postMessage({ type: 'SKIP_WAITING' })
            }
          })
        })
      })
      .catch((error) => {
        console.warn('Service worker registration failed', error)
      })
  })
}
